import * as React from 'react';
import MainHeader from '../../headers/MainHeader/MainHeader';
import NoProjectFoundHeader from '../../pages/project/NoProjectFoundHeader/NoProjectFoundHeader';

function NoProjectFound() {
    return (
        <div className="no-project-found">
            <MainHeader>
                <NoProjectFoundHeader />
            </MainHeader>
            <div className="no-project-found_content">
                Project does not exist
            </div>
        </div>
    );
}

export default NoProjectFound;